import React from "react";
import { Link } from "react-router-dom";
import { Table, Space, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import { SearchRequest } from "../../services/api/interfaces/ApiRequest";
import { SearchOptions } from "../TableHelper";
import { Pagination } from "components/Pagination";

type MappingAgeRangeListProps = BaseListComponentProps & {
  loading: boolean;
  mappingAgeRanges: any;
  pagination: any;
  history?: any;

  loadMappingAgeRanges: (args: SearchRequest) => void;

  onLoad?: (searchOptions: SearchOptions) => void;
};

export default class MappingAgeRangeList extends ListComponent<MappingAgeRangeListProps> {
  static defaultProps = {
    loading: false,
    mappingAgeRanges: [],

    loadMappingAgeRanges: () => {},
  };

  tableColumns = [
    {
      title: "Specie",
      dataIndex: ["specie", "name"],
      key: "specie_id",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.specie?.name - b.specie?.name,
    },
    {
      title: "Age Key",
      dataIndex: "age_key",
      key: "age_key",
      sorter: (a: any, b: any) => a.age_key - b.age_key,
    },
    {
      title: "Minimum",
      dataIndex: "min",
      key: "min",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.min - b.min,
    },
    {
      title: "Maximum",
      dataIndex: "max",
      key: "max",
      responsive: ["md"] as any,
      sorter: (a: any, b: any) => a.max - b.max,
    },
    {
      title: "Actions",
      key: "action",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Link
            to={`age-range/${record.uuid}`}
            ref={(refs) => this.actionRefs.edit.push(refs)}
          >
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      ),
    },
  ];

  protected load() {
    this.searchOptions = {
      search: {
        specie: {
          with: true,
        },
      },
      options: {
        ...this.searchOptions.options,
        _force_ids: true,
        sort: ["min"],
      },
    };

    this.props.loadMappingAgeRanges(this.searchOptions);

    if (this.props.onLoad) {
      this.props.onLoad(this.searchOptions);
    }
  }

  render() {
    const { loading, pagination, mappingAgeRanges, loadMappingAgeRanges } =
      this.props;

    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={mappingAgeRanges}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadMappingAgeRanges)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={mappingAgeRanges?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadMappingAgeRanges)
          }
        />
      </>
    );
  }
}
